// extracted by mini-css-extract-plugin
export var articlesTitle = "author-reviewer-module--articlesTitle--b2951";
export var authorCurrentlyUsing = "author-reviewer-module--authorCurrentlyUsing--eb1f1";
export var authorHeader = "author-reviewer-module--authorHeader--845d8";
export var authorSummary = "author-reviewer-module--authorSummary--3b0ae";
export var avatar = "author-reviewer-module--avatar--1e9c4";
export var breadcrumb = "author-reviewer-module--breadcrumb--bcc4e";
export var buttonRow = "author-reviewer-module--buttonRow--b9645";
export var currentlyUsing = "author-reviewer-module--currentlyUsing--99016";
export var expertiseOccupation = "author-reviewer-module--expertiseOccupation--aa54e";
export var genericContainer = "author-reviewer-module--genericContainer--1ca7c";
export var gridContainer = "author-reviewer-module--gridContainer--a2dd0";
export var gridStaticContainer = "author-reviewer-module--gridStaticContainer--06d92";
export var icon = "author-reviewer-module--icon--be7fe";
export var infoBlock = "author-reviewer-module--infoBlock--39ad3";
export var lastSection = "author-reviewer-module--lastSection--a594c";
export var learnMoreButton = "author-reviewer-module--learnMoreButton--9f4b1";
export var line = "author-reviewer-module--line--6b44e";
export var name = "author-reviewer-module--name--27075";
export var paragraph = "author-reviewer-module--paragraph--f4de7";
export var productImage = "author-reviewer-module--productImage--1828c";
export var productItem = "author-reviewer-module--productItem--e7556";
export var productName = "author-reviewer-module--productName--50c91";
export var socialMedia = "author-reviewer-module--socialMedia--d0f44";
export var subscription = "author-reviewer-module--subscription--3a62a";
export var summaryTitle = "author-reviewer-module--summaryTitle--2dec5";
export var titleAndSubscribe = "author-reviewer-module--titleAndSubscribe--7d515";